import * as React from "react";
import { cn } from "@/utils/utils";

export type LogoProps = {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  className?: string;
  title?: string;
  /** Primary brand color (big right shape) */
  primary?: string;
  /** Secondary brand color (big left shape) */
  secondary?: string;
  /** Contrast color (inner circles) */
  contrast?: string;
};

/**
 * Logo
 * - Renders an inline SVG (no network fetch)
 * - Dimensions configurable via size or width/height
 * - Colors configurable via props (defaults respect theme)
 */
export function Logo({
  size = 24,
  width,
  height,
  className,
  title = "Logo",
  primary = "#3548ff",
  secondary = "#7b8aff",
  contrast = "#ffffff",
}: LogoProps) {
  const w = width ?? size;
  const h = height ?? size;


  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1820 1774.9" width={w} height={h} className={cn("shrink-0", className)}>
      <g id="Layer_1-2" data-name="Layer 1">
        <circle fill="#fff" cx="1054.53" cy="779.52" r="386.21" />
        <g>
          <path fill="#8ac2ff" d="M5.91,1004.47L0,1768.96l764.5,5.91c422.08,3.27,767.15-336.52,770.42-758.58,3.26-422.06-336.51-767.14-758.59-770.41C350.68,242.59,9.18,582.4,5.91,1004.47Z" />
          <path fill="#3548ff" d="M1820,764.52V0h-764.52C633.38,0,290.95,342.44,290.95,764.52s342.43,764.52,764.52,764.52,764.52-342.44,764.52-764.52Z" />
          <circle fill="#fff" cx="1055.48" cy="780.55" r="382.26" />
        </g>
      </g>
    </svg>
  );
}

export default Logo;